// src/components/ProtectedRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export function RootRoute() {
  const { user, initializing } = useContext(AuthContext);

  // Enquanto decide, não redireciona
  if (initializing) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}

export default function ProtectedRoute({ children }) {
  const { user, initializing } = useContext(AuthContext);

  // Enquanto decide, não redireciona
  if (initializing) {
    return null; // ou um spinner
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
